import styled from 'styled-components';
import { DivWithShadowAlternate, LinkSmall } from '@styled';
import colors from '@general/colors';
import { mediaQueries } from '@general/breakpoints';

export const PdfCardContainer = styled(DivWithShadowAlternate)`
    background-color: white;
    width: auto;

    @media ${mediaQueries.md} {
        width: 794px;
    }
`;

export const PdfCardBody = styled.div`
    padding: 20px 24px 32px 24px;

    @media ${mediaQueries.md} {
        padding: 50px 44px 88px 44px;
    }
`;

export const PrimaryAccentHr = styled.hr`
    border-top-width: 6px;
    border-color: ${colors.primary};
    margin: 0;
`;

// Button that looks like a LinkSmall — used for async-triggered PDF opens where
// an <a href> can't be used because the URL is fetched on demand.
export const PdfLinkButton = styled(LinkSmall).attrs({ as: 'button' })`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
`;
